import { LP } from '@/types/LP.types'

export default {
  layoutProfileItems: [] as LP.Item[],
  layoutProfileItemsById: {} as Record<number, LP.Item>,
}
